import React from 'react';
import { Calendar, Clock, User, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BlogCard = ({ post, featured = false }) => {
  const navigate = useNavigate();

  const handleReadMore = () => {
    navigate(`/blog/${post.slug}`);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  if (featured) {
    return (
      <article className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        <div className="md:flex">
          <div className="md:w-1/2">
            <img
              src={post.image}
              alt={post.title}
              className="w-full h-64 md:h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="md:w-1/2 p-6 md:p-8">
            <div className="flex items-center gap-4 mb-4">
              <span className="bg-teal-100 text-teal-800 text-xs font-semibold px-3 py-1 rounded-full">
                {post.category}
              </span>
              <span className="bg-orange-100 text-orange-800 text-xs font-semibold px-3 py-1 rounded-full">
                Featured
              </span>
            </div>

            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 line-clamp-2">
              {post.title}
            </h2>

            <p className="text-gray-600 mb-4 line-clamp-3">
              {post.excerpt}
            </p>

            <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
              <div className="flex items-center gap-1">
                <User className="w-4 h-4" />
                <span>{post.author}</span>
              </div>
              <div className="flex items-center gap-1">
                <Calendar className="w-4 h-4" />
                <span>{formatDate(post.publishedDate)}</span>
              </div>
              <div className="flex items-center gap-1">
                <Clock className="w-4 h-4" />
                <span>{post.readTime}</span>
              </div>
            </div>

            <button
              onClick={handleReadMore}
              className="inline-flex items-center gap-2 text-teal-600 hover:text-teal-800 font-semibold transition-colors group"
            >
              Read More
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </div>
      </article>
    );
  }

  return (
    <article className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
      <img
        src={post.image}
        alt={post.title}
        className="w-full h-48 object-cover"
        loading="lazy"
      />

      <div className="p-6">
        <div className="flex items-center gap-2 mb-3">
          <span className="bg-teal-100 text-teal-800 text-xs font-semibold px-3 py-1 rounded-full">
            {post.category}
          </span>
        </div>

        <h3 className="text-lg font-bold text-gray-900 mb-2 line-clamp-2">
          {post.title}
        </h3>

        <p className="text-gray-600 mb-4 line-clamp-3 text-sm">
          {post.excerpt}
        </p>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 text-xs text-gray-500">
            <div className="flex items-center gap-1">
              <Calendar className="w-3 h-3" />
              <span>{formatDate(post.publishedDate)}</span>
            </div>
            <div className="flex items-center gap-1">
              <Clock className="w-3 h-3" />
              <span>{post.readTime}</span>
            </div>
          </div>

          <button
            onClick={handleReadMore}
            className="text-teal-600 hover:text-teal-800 font-semibold text-sm transition-colors"
          >
            Read More →
          </button>
        </div>
      </div>
    </article>
  );
};

export default BlogCard;
